import { PageHeader } from '../../components/PageHeader';
import { ExcepcionesTable } from './components/ExcepcionesTable';
import { useT } from '../../locales';

export function ExcepcionesListPage() {
  const t = useT();
  return (
    <div>
      <PageHeader title={t('pages.excepciones.title')} subtitle={t('pages.excepciones.subtitle')} />
      <ExcepcionesTable />
    </div>
  );
}
